import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: [
    '../../shared/Styles/public-page.css',
    './terms-and-conditions.component.css'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TermsAndConditionsComponent {
  public readonly sectionIds = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  public readonly paragraphIds = [1, 2];
}
